<template>
  <a :href="valueHandler" :title="valueHandler"
     target="_blank"
     class="full-link"
  >
    <i class="fas fa-external-link-alt"></i>
  </a>
</template>

<script>
import DataTypeProsMixin from 'CORE/mixins/dataType'
import { get } from 'lodash'
import { createDataTypeValue } from '../utils'

export default {
    name: 'UrlDetail',
    mixins: [
        DataTypeProsMixin,
    ],
    data() {
        return {
        }
    },
    computed: {
        valueHandler: {
            get() {
                return get(this, 'value.value.value', null)
            },
            set(value) {
                this.$emit('input', createDataTypeValue(value))
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.full-link {
    width: 100%;
    display: block;
    text-align: center;
}
</style>
